import api, { API_BASE_URL } from '../api';
import { useContext, useEffect, useReducer, useState, useRef } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/esm/Col';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/esm/Button';
import { Helmet } from 'react-helmet-async';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MeaasgeBox';
import { getError } from '../Util';
import { Store } from '../Store';
import CardHeader from '../components/CardHeadder';
import { Container } from 'react-bootstrap';
import { assets } from '../assets/assets';
import { Modal } from 'react-bootstrap';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      const fabric = action.payload.fabricDetails;
      if (fabric && fabric.description) {
        fabric.description = Array.isArray(fabric.description)
          ? fabric.description
          : (typeof fabric.description === 'string' ? [fabric.description] : []);
      }
      return {
        ...state,
        product: action.payload,
        loading: false,
        fabric: fabric,
      };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    case 'FETCH_RELATED_SUCCESS':
      return { ...state, relatedProducts: action.payload, loadingRelated: false };
    case 'FETCH_RELATED_FAIL':
      return { ...state, loadingRelated: false };
    default:
      return state;
  }
};

function ProductScreen() {
  const [showSizeChart, setShowSizeChart] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const { slug } = params;
  const [selectedImage, setSelectedImage] = useState('');
  const descriptionRef = useRef(null);
  
  const [{ loading, error, product, fabric, relatedProducts }, dispatch] = useReducer(reducer, {
    product: [],
    loading: true,
    error: '',
    fabric: null,
    relatedProducts: [],
    loadingRelated: true,
    initial: true,
  });

  // Fix relative links in description
  useEffect(() => {
    if (descriptionRef.current && product && product.description) {
      const links = descriptionRef.current.querySelectorAll('a');
      links.forEach(link => {
        const href = link.getAttribute('href');
        if (href && !href.startsWith('http') && !href.startsWith('mailto') && !href.startsWith('tel') && !href.startsWith('#') && !href.startsWith('/')) {
          link.setAttribute('href', `https://${href}`);
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        } else if (href && href.startsWith('http')) {
           // Ensure external links open in new tab
           link.setAttribute('target', '_blank');
           link.setAttribute('rel', 'noopener noreferrer');
        }
      });
    }
  }, [product]);
  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const result = await api.get(`/api/products/slug/${slug}`);
        dispatch({ type: 'FETCH_SUCCESS', payload: result.data });

        // Fetch related products
        try {
          const { data } = await api.get(`/api/products/search?category=${result.data.category}&pageSize=4`);
          dispatch({ type: 'FETCH_RELATED_SUCCESS', payload: data.products.filter(p => p._id !== result.data._id) });
        } catch (err) {
          dispatch({ type: 'FETCH_RELATED_FAIL' });
        }

      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: getError(err) });
      }
    };
    fetchData();
  }, [slug]);

  // Fabric details are now loaded in the main product fetch

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { cart } = state;
  const [quantity, setQuantity] = useState(1);

  const addToCartHandler = async () => {
    const hasSizes = product.sizes && product.sizes.length > 0;
    const hasColors = hasSizes && product.sizes.some(s => s.colors.some(c => c.color && c.color !== ''));
    const currentSizeColors = (hasSizes && selectedSize) ? product.sizes.find(s => s.size === selectedSize)?.colors.filter(c => c.color && c.color !== '') : [];

    if (hasSizes && !selectedSize) {
      window.alert('Please select a size');
      return;
    }

    if (hasColors && currentSizeColors && currentSizeColors.length > 0 && !selectedColor) {
      window.alert('Please select a color');
      return;
    }

    const existItem = cart.cartItems.find(
      (x) => x._id === product._id && x.selectedSize === selectedSize && x.selectedColor === selectedColor
    );

    const quantityToAdd = existItem ? existItem.quantity + quantity : quantity;

    const { data } = await api.get(`/api/products/${product._id}`);


    ctxDispatch({
      type: 'CART_ADD_ITEM',
      payload: { ...product, quantity: quantityToAdd, selectedSize, selectedColor },
    });

    navigate('/cart');
  };

  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedColor, setSelectedColor] = useState(null);

  return loading ? (
    <LoadingBox />
  ) : error ? (
    <MessageBox variant="danger">{error}</MessageBox>
  ) : (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-3">
        <div className="d-flex justify-content-start">
          <Button
            onClick={() => navigate('/products')}
            style={{
              backgroundColor: '#801001',
              color: 'white',
              border: 'none',
              fontWeight: 'bold',
              padding: '0.5rem 1.2rem',
              fontSize: '1rem',
              borderRadius: '50px',
              transition: 'all 0.3s ease', // smooth animation
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#a0120f'; // slightly lighter red
              e.target.style.boxShadow = '0px 4px 15px rgba(0,0,0,0.2)'; // subtle shadow
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#801001';
              e.target.style.boxShadow = 'none';
            }}
          >
            ← Back to Products
          </Button>
        </div>
      </Container>

      <Container fluid="md" className="mt-3 py-3">
        <div>
          <Row>
            <Col md={6}>
              <img
                className="img-large"
                src={selectedImage || product.image ? ((selectedImage || product.image).startsWith('http') ? (selectedImage || product.image) : `${API_BASE_URL}/storage/${selectedImage || product.image}`) : ''}
                alt={product.name}
                style={{
                  width: '100%', // Set the width to 100% of the parent container (or use a fixed value like '200px')
                  height: '600px', // Set a fixed height for the image
                  objectFit: 'cover', // Ensure the image covers the area without distortion
                }}
              ></img>
              <ListGroup.Item>
                <Row xs="auto" className="g-2 d-flex flex-nowrap">
                  {[product.image, ...(product.images || [])].map((x) => (
                    <Col key={x}>
                      <Card>
                        <Button
                          className="thumbnail"
                          type="button"
                          variant="light"
                          onClick={() => setSelectedImage(x)}
                        >
                          <Card.Img
                            className="thumbnail-img"
                            variant="top"
                            src={x ? (x.startsWith('http') ? x : `${API_BASE_URL}/storage/${x}`) : ''}
                            alt="product"
                          />
                        </Button>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </ListGroup.Item>
            </Col>
            <Col md={5}>
              <ListGroup>
                <ListGroup.Item>
                  <Helmet>
                    <title>{product.name}</title>
                  </Helmet>
                  <h1 style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                    {product.name}
                  </h1>
                </ListGroup.Item>
                <ListGroup.Item
                  style={{
                    color: '#801001',
                    fontSize: '1.5rem',
                    fontWeight: 'bold',
                  }}
                >
                  <Row>
                    <Col>ID: {product.code}</Col>
                  </Row>
                </ListGroup.Item>

                <ListGroup.Item>
                  <strong>Category :-</strong> {product.category}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong> Fabric :-</strong> {product.fabric}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong> Brand :-</strong> {product.brand}
                </ListGroup.Item>

              </ListGroup>

              <ListGroup.Item>
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowSizeChart(true)}
                  className="mt-2"
                >
                  <i className="fas fa-ruler"></i> Size Chart
                </Button>
              </ListGroup.Item>

              <Card style={{ marginTop: '20px' }}>
                <Card.Body>
                  <ListGroup variant="flush">
                    {product.sizes && product.sizes.length > 0 && (
                      <ListGroup.Item>
                        <div className="d-flex align-items-center">
                          <span style={{ marginRight: '15px', fontWeight: '500' }}>Size:</span>
                          <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                            {product.sizes.map((size) => (
                              <div
                                key={size.size}
                                style={{
                                  border: '1px solid #ddd',
                                  borderRadius: '5px',
                                  padding: '8px 16px',
                                  cursor: 'pointer',
                                  backgroundColor:
                                    selectedSize === size.size
                                      ? '#801001'
                                      : '#f8f9fa',
                                  color:
                                    selectedSize === size.size
                                      ? 'white'
                                      : 'black',
                                  fontSize: '14px',
                                  minWidth: '50px',
                                  textAlign: 'center',
                                  transition: 'all 0.2s ease',
                                }}
                                onClick={() => setSelectedSize(size.size)}
                              >
                                {size.size}
                              </div>
                            ))}
                          </div>
                        </div>
                      </ListGroup.Item>
                    )}

                    {selectedSize && product.sizes.find(s => s.size === selectedSize)?.colors.some(c => c.color && c.color !== '') && (
                      <ListGroup.Item>
                        <div className="d-flex align-items-center">
                          <span style={{ marginRight: '15px', fontWeight: '500' }}>Color:</span>
                          <div className="d-flex flex-wrap align-items-center" style={{ gap: '8px' }}>
                            {product.sizes
                              .find((s) => s.size === selectedSize)
                              ?.colors.filter(c => c.color && c.color !== '')
                              .map((c) => (
                                <div
                                  key={c.color}
                                  style={{
                                    border: '1px solid #ddd',
                                    borderRadius: '20px',
                                    padding: '6px 16px',
                                    cursor: 'pointer',
                                    backgroundColor:
                                      selectedColor === c.color
                                        ? '#801001'
                                        : '#f8f9fa',
                                    color:
                                      selectedColor === c.color
                                        ? 'white'
                                        : 'black',
                                    fontSize: '14px',
                                    transition: 'all 0.2s ease',
                                  }}
                                  onClick={() => setSelectedColor(c.color)}
                                >
                                  {c.color}
                                </div>
                              ))}
                          </div>
                        </div>
                      </ListGroup.Item>
                    )}

                    <ListGroup.Item>
                      <Row className="align-items-center">
                        <Col md={3}>Quantity:</Col>
                        <Col md={9}>
                          <div className="d-flex align-items-center gap-2">
                            {/* Decrease by 5 */}
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                setQuantity((q) => Math.max(1, q - 5))
                              }
                              disabled={quantity <= 1}
                            >
                              <i className="fas fa-minus-circle"></i>
                            </Button>

                            {/* Decrease by 1 */}
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                setQuantity((q) => Math.max(1, q - 1))
                              }
                              disabled={quantity === 1}
                            >
                              <i className="fas fa-minus"></i>
                            </Button>

                            {/* Quantity Display */}
                            <span
                              style={{
                                minWidth: '30px',
                                textAlign: 'center',
                                fontWeight: 'bold',
                              }}
                            >
                              {quantity}
                            </span>

                            {/* Increase by 1 */}
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                setQuantity((q) => q + 1)
                              }
                            >
                              <i className="fas fa-plus"></i>
                            </Button>

                            {/* Increase by 5 */}
                            <Button
                              style={{ color: '#801001' }}
                              variant="light"
                              onClick={() =>
                                setQuantity((q) => q + 5)
                              }
                            >
                              <i className="fas fa-plus-circle"></i>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </ListGroup.Item>

                    {/* Size Chart Modal */}
                    <Modal
                      show={showSizeChart}
                      onHide={() => setShowSizeChart(false)}
                      size="lg"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Size Chart</Modal.Title>
                      </Modal.Header>
                      <Modal.Body
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={product.sizeChartImage ? (product.sizeChartImage.startsWith('http') ? product.sizeChartImage : `${API_BASE_URL}/storage/${product.sizeChartImage}`) : assets.ROAD_MAP}
                          alt="Size Chart"
                          style={{
                            width: '70%',
                            height: 'auto',
                            display: 'block',
                          }}
                        />
                      </Modal.Body>
                    </Modal>

                    <ListGroup.Item>
                      <div className="d-grid shadow-sm">
                        {(() => {
                          const hasSizes = product.sizes && product.sizes.length > 0;
                          const needsSize = hasSizes && !selectedSize;
                          const currentSizeColors = (hasSizes && selectedSize) 
                            ? product.sizes.find(s => s.size === selectedSize)?.colors.filter(c => c.color && c.color !== '') 
                            : [];
                          const needsColor = selectedSize && currentSizeColors && currentSizeColors.length > 0 && !selectedColor;
                          const isDisabled = needsSize || needsColor;
                          
                          let buttonText = 'Add to cart';
                          if (needsSize) buttonText = 'Select a Size';
                          else if (needsColor) buttonText = 'Select a Color';
                          
                          return (
                            <Button
                              onClick={addToCartHandler}
                              disabled={isDisabled}
                              style={{
                                backgroundColor: isDisabled ? '#a0a0a0' : '#801001',
                                color: 'white',
                                border: 'none',
                                fontWeight: 'bold',
                                padding: '0.8rem',
                                borderRadius: '8px',
                                transition: 'all 0.3s',
                                cursor: isDisabled ? 'not-allowed' : 'pointer'
                              }}
                            >
                              {buttonText}
                            </Button>
                          );
                        })()}
                      </div>
                    </ListGroup.Item>
                  </ListGroup>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <section
          className="container mx-auto px-4 sm:px-6 lg:px-8 py-8"
          id="who we are"
        >
          <div className="w-full max-w-none text-left">
            {/* Changed from text-center to text-left */}
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 text-customRed">
              Product More Descriptions
            </h1>
            <div 
              ref={descriptionRef}
              className="text-gray-600 text-lg mb-8 leading-relaxed w-full rich-text-content"
              dangerouslySetInnerHTML={{ __html: product.description }}
            ></div>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed w-full">
              As Kobithan Garments (PVT) LTD we pride ourselves on our ability
              to craft high- quality products with efficiency and precision. We
              employ our advanced technology techniques to craft products that
              exceed international quality benchmarks, ensuring reliability and
              style for global markets.
            </p>
          </div>
        </section>

        <section
          className="container mx-auto px-4 sm:px-6 lg:px-8 py-8"
          id="export-grade-stitching"
        >
          <div className="w-full max-w-none text-left">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold mb-6 text-customRed">
              Fabric More Details
            </h1>
          </div>

          <div className="flex flex-col lg:flex-row items-center lg:items-start">
            <div className="lg:w-1/2 w-full text-left">
              {fabric ? (
                <>
                  <h2 className="text-xl font-semibold mb-4">{fabric.name}</h2>
                  <div className="space-y-4">
                    {fabric.description.map((point, index) => (
                      <p
                        key={index}
                        className="text-gray-600 text-lg leading-relaxed"
                      >
                        • {point}
                      </p>
                    ))}
                  </div>
                </>
              ) : (
                <LoadingBox small />
              )}
            </div>

            <div className="lg:w-1/2 w-full flex justify-center lg:justify-end mt-6 lg:mt-0">
              <img
                src={fabric?.image ? (fabric.image.startsWith('http') ? fabric.image : `${API_BASE_URL}/storage/${fabric.image}`) : assets.ROAD_MAP}
                alt="Fabric Details"
                className="w-full max-w-sm lg:max-w-md object-cover rounded-lg shadow-lg"
              />
            </div>
          </div>
        </section>

        {relatedProducts.length > 0 && (
          <section className="container mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6 text-customRed">Related Products</h2>
            <Row>
              {relatedProducts.map((related) => (
                <Col key={related._id} sm={6} md={4} lg={3} className="mb-4">
                  <Card className="h-100 shadow-sm border-0 rounded-4 overflow-hidden transform transition hover:-translate-y-1">
                    <Link to={`/product/${related.slug}`}>
                      <Card.Img 
                        variant="top" 
                        src={related.image ? (related.image.startsWith('http') ? related.image : `${API_BASE_URL}/storage/${related.image}`) : ''} 
                        style={{ height: '200px', objectFit: 'cover' }}
                      />
                    </Link>
                    <Card.Body>
                      <Card.Title className="fs-6 fw-bold text-truncate">{related.name}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </section>
        )}
      </Container>
    </div>
  );
}
export default ProductScreen;
